export const SYSTEM_INFORMATIONS_RESET_STATE = 'SYSTEM_INFORMATIONS_RESET_STATE';
export const SYSTEM_INFORMATIONS_CURRENT_ITEM = 'SYSTEM_INFORMATIONS_CURRENT_ITEM';

export const SYSTEM_INFORMATIONS_REQUEST_LOADING = 'SYSTEM_INFORMATIONS_REQUEST_LOADING';
export const SYSTEM_INFORMATIONS_REQUEST_SUCCESS = 'SYSTEM_INFORMATIONS_REQUEST_SUCCESS';
export const SYSTEM_INFORMATIONS_REQUEST_FAILED = 'SYSTEM_INFORMATIONS_REQUEST_FAILED';

export const SYSTEM_INFORMATIONS_CURRENT_ACTION = 'SYSTEM_INFORMATIONS_CURRENT_ACTION';
export const SYSTEM_INFORMATIONS_RESET_ACTION = 'SYSTEM_INFORMATIONS_RESET_ACTION';